const MICROSECONDS_PER_MILLISECOND = 1000;
export default {
  serialize(date) {
    if (date !== null && date !== undefined) {
      return {
        instant_usec: date.valueOf() * MICROSECONDS_PER_MILLISECOND
      };
    } else {
      return undefined;
    }
  },
  deserialize(proto) {
    if (proto !== null && proto !== undefined) {
      return new Date(proto.instant_usec / MICROSECONDS_PER_MILLISECOND);
    } else {
      return undefined;
    }
  }
};